exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-1c645367]:disabled {\n    cursor: not-allowed;\n}\n", ""]);

// exports
